// ABOUTME: React application entry point for PhotoStream frontend with AWS Amplify configuration
// ABOUTME: Renders the main App component and configures authentication services

import React from 'react';
import ReactDOM from 'react-dom/client';
import './globals.css';
import App from './App';
import { configureAmplify } from './lib/amplify-config';

// Configure AWS Amplify
configureAmplify();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
